// extracted by mini-css-extract-plugin
export default {"container":"style_container__Rn-xD","header":"style_header__Svog4","content":"style_content__u4MRk"};